module.exports = __webpack_public_path__ + "static/media/2018.400db721.csv";